// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609230857/js/" + chunkId + "." + {"44":"d2a7bbc9","225":"139511f9","481":"49b22d5d","486":"5b25bc72","770":"4fd11cc7"}[chunkId] + ".0.8025797516411662.chunk.js";
};